import { render, staticRenderFns } from "./StorePopup.vue?vue&type=template&id=704735f4&scoped=true&"
import script from "./StorePopup.vue?vue&type=script&lang=js&"
export * from "./StorePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704735f4",
  null
  
)

export default component.exports